import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { ColumnComponent } from '../column.component';

@Component({
  selector: 'app-column-grading-results',
  templateUrl: './column-grading-results.component.html',
  styleUrl: './column-grading-results.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class ColumnGradingResultsComponent extends ColumnComponent {
  @Input() reset: boolean;
  @Input() useNgContent: boolean;
}
